import Axios from "axios";

interface IViagsDepartment {
  code: string;
  dep_ID: number;
  name_VN: string;
  parentID: number;
}

export interface IViagsLeaveInfo {
  address: string;
  birthDay: string;
  code_Sex: string;
  companyDate: string;
  departments: string;
  fullName: string;
  hR_ID: 385;
  hR_No: string;
  listDepartment: IViagsDepartment[];
  majorDate: string;
  mobile_1: string;
  mobile_2: string;
  paidLeave_Remain: number;
  paidLeave_Remain_Early: number;
  paidLeave_Used_Total: number;
  paidLeave_Year: number;
  permanent: string;
  code_Job_Title: string;
  jobTitle_NameVN: string;
}

export class AFLViagsService {
  static baseURL: string = "https://viagsapi.azurewebsites.net/api/viagsapi";

  static getLeaveInfo(hrNo: string) {
    const url = `${AFLViagsService.baseURL}/get-leave-info?hrNo=${hrNo}`;
    return Axios.get<{ data: IViagsLeaveInfo[] }>(url).then(
      (response) => response.data?.data
    );
  }
}
